import React__default from "react";
import { useId } from "@floating-ui/react";
import { Icon } from "../icon/icon/icon.mjs";
import { useLabels } from "../helpers/label-provider/use-labels.mjs";
const Chip = (props) => {
  const labels = useLabels();
  const id = useId();
  const chipRemoveId = "".concat(id, "-remove");
  const { children, className, disabled, label, onRemove, removeButtonLabel } = props;
  const BEM = () => {
    const classArray = ["chip"];
    if (disabled) {
      classArray.push("is-disabled");
    }
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  };
  const onRemoveClick = (event) => {
    event.preventDefault();
    if (onRemove) {
      onRemove(event);
    }
  };
  return /* @__PURE__ */ React__default.createElement("div", { className: BEM() }, /* @__PURE__ */ React__default.createElement("div", { id }, "".concat(label ? "".concat(label, ": ") : ""), children), onRemove && /* @__PURE__ */ React__default.createElement("button", { id: chipRemoveId, type: "button", className: "chip__remove", onClick: onRemoveClick, disabled, "aria-labelledby": "".concat(chipRemoveId, " ").concat(id) }, /* @__PURE__ */ React__default.createElement(Icon, { modifiers: "#close-round", size: "xxs", className: "chip__remove-icon" }), /* @__PURE__ */ React__default.createElement("span", { className: "sr-only" }, removeButtonLabel != null ? removeButtonLabel : labels.get("remove"))));
};
export {
  Chip
};
